import type { WebhookChannel, WebhookProcessingStatus, WebhookProvider } from "./types";

export const WEBHOOK_MODULE = "Webhook Integration";

export const INTEGRATION_STATUS = {
  DISABLED: 0,
  ACTIVE: 1,
} as const;

export const EVENTS_PAGE_SIZE = 20;

export const channelOptions: {
  value: WebhookChannel;
  label: string;
  icon: string;
  description: string;
}[] = [
  {
    value: "whatsapp",
    label: "WhatsApp",
    icon: "ti ti-brand-whatsapp",
    description: "Receive WhatsApp chats and leads from your provider",
  },
];

export const providerOptions: Record<
  WebhookChannel,
  { value: WebhookProvider; label: string; description: string }[]
> = {
  whatsapp: [
    {
      value: "fonada",
      label: "Fonada",
      description: "WhatsApp Business messages and ad leads via Fonada",
    },
  ],
};

export const providerLabels: Record<WebhookProvider, string> = {
  fonada: "Fonada",
};

export const processingStatusColors: Record<WebhookProcessingStatus, string> = {
  received: "blue",
  processed: "green",
  ignored: "default",
  failed: "red",
};

export const WEBHOOK_SECRET_HEADER = "X-Webhook-Secret";

export const fonadaSetupSteps = [
  "Log in to the Fonada dashboard and open the webhook settings for this WhatsApp number.",
  "Paste the webhook URL shown above.",
  `Under Custom Headers, add ${WEBHOOK_SECRET_HEADER} as the header name and your secret as the value.`,
  "Turn on message received, status update and URL click events, then save.",
  "Send a test WhatsApp message to your business number and check Recent events.",
];
